define('Components/LandingWidget/js/LandingWidget',['hooks',
    //
    'Components/LandingWidget/js/models/LandingWidgetInstanceModel',
    'Components/LandingWidget/js/models/SummerBoxWidgetInstanceModel',
    //
    'Components/LandingWidget/js/views/LandingWidgetInstanceView',
    'Components/LandingWidget/js/views/FidelityWidgetInstanceView',
    'Components/LandingWidget/js/views/SummerBoxWidgetInstanceView',
    'Components/LandingWidget/js/views/SummerCreationsWidgetInstanceView',
],
    function(hooks,
        //
        LandingWidgetInstanceModel,
        SummerBoxWidgetInstanceModel,
        //
        LandingWidgetInstanceView,
        FidelityWidgetInstanceView,
        SummerBoxWidgetInstanceView,
        SummerCreationsWidgetInstanceView
    ){
    return function() {
        hooks.registerWidgetInstance('LandingWidget', {
            'autumn-creation':LandingWidgetInstanceView,
            'box-sarah':LandingWidgetInstanceView,
            'corners':LandingWidgetInstanceView,
            'fidelity':FidelityWidgetInstanceView,
            'summer-creations':SummerCreationsWidgetInstanceView,
            'summer-box':SummerBoxWidgetInstanceView,
            'wuaki':LandingWidgetInstanceView,
        },{
            'summer-box':SummerBoxWidgetInstanceModel,
         });
    }
});
